export default "__VITE_ASSET__3306e1df__"